<template>
  <div style="position: relative;padding-bottom: 40px;">
    <ml-table
      :columns="columns"
      :dataSource="dataList"
      :scroll="{ x: tableScrollWidth, y: tableScrollY }"
      style="background-color: #fff; margin: 0 10px"
    >
      <template slot="actions" slot-scope="text, record">
        <div style="display: flex">
          <a
            :style="{
              display: record.applyStatus === 1 ? 'block' : 'none',
              marginLeft: '28px',
            }"
            @click="handleApply(record)"
            >{{ $t("page_plan_maintenance_edit_execution") }}</a
          >
          <a
            :style="{
              display: record.applyStatus === 1 ? 'none' : 'block',
            }"
            @click="changeRecord(record)"
            >{{ $t("page_tpm_repair_registration_records") }}</a
          >
          <a @click="viewAttachment(record)" style="margin-left: 10px">{{
            $t("page_tpm_check_watch_file")
          }}</a>
        </div>
      </template>
    </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          :total="pagination.total"
          :showTotal="total => `${totalFanyi(total)}`"
          :pageSize="pagination.pageSize"
          :current="pagination.current"
          @change="pageIndexchange"
        ></a-pagination>
    <AttachmentModal
      :visible="attachVisible"
      :data="attachmentInfo"
      @close="closeAttachmentModal"
    />
    <a-modal
      :title="$t('page_device_repair_record_details')"
      :visible="visible"
      :confirm-loading="saveLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <AddOrEditForm
        ref="_form_add"
        :visible="visible"
        :deviceTypeId="deviceTypeId"
        type="add"
        :apply="apply"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  WarningServiceProxy,
  RepairApplyServiceProxy,
  RepairRecordServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import dayjs from "dayjs";
import AttachmentModal from "@/views/tpm/repair-apply/components/AttachmentModal";
import AddOrEditForm from "@/views/tpm/repair-record/components/AddOrEditForm";
const warningServiceProxy = new WarningServiceProxy();
const rasp = new RepairApplyServiceProxy();
const repairRecordServiceProxy = new RepairRecordServiceProxy();
export default {
  components: {
    AttachmentModal,
    AddOrEditForm,
  },
  data() {
    return {
      dataList: [],
      tableScrollWidth: 1700,
      tableScrollY: 300,
      attachVisible: false, // 附件模态框
      attachmentInfo: {}, // 附件信息
      visible: false,
      apply: { applyCode: "", applyId: "" },
      deviceTypeId: "",
      saveLoading: false,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
    };
  },
  created() {
    this.getPageRepairApply();
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "actions",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "actions" },
        },
        {
          title: this.$t("page_plan_maintenance_application_No"),
          dataIndex: "applyCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_application_form_status_jian"),
          dataIndex: "applyStatusStr",
          width: 100,
          ellipsis: true,
          // customRender: (text) => this.recordStatusMap[text]
        },
        {
          title: this.$t("page_tpm_repair_urgency_jian"),
          dataIndex: "urgencyStr",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_check_device_code"),
          dataIndex: "deviceCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_check_device_name"),
          dataIndex: "deviceName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_tpm_check_device_type"),
          dataIndex: "deviceTypeName",
          width: 100,
          ellipsis: true,
        },
        // { title: this.$t('规格型号'), dataIndex: 'code', width: 100, ellipsis: true },
        {
          title: this.$t("page_tpm_repair_occurrence_time"),
          dataIndex: "malfunctionTime",
          width: 150,
          ellipsis: true,
          customRender: (text) =>
            text ? dayjs(text).format("YYYY-MM-DD HH:mm:ss") : "",
        },
        {
          title: this.$t("page_tpm_repair_apply_person_jian"),
          dataIndex: "applyUserName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_extranet_Fault_description"),
          dataIndex: "description",
          width: 100,
          ellipsis: true,
        },
      ];
    },
  },
  methods: {
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.getPageRepairApply()
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    async viewAttachment(record) {
      this.attachVisible = true;
      this.attachmentInfo = await rasp.getApplyFile(record.id);
    },

    closeAttachmentModal() {
      this.attachVisible = false;
    },
    async getPageRepairApply() {
      let result = await warningServiceProxy.getPageRepairApply(
        this.pagination.current,
        this.pagination.pageSize
      );
      this.dataList = result.records;
      this.pagination.total = result.total;
    },
    async handleApply(record) {
      let res = await rasp.implementRepairApply(record.id);
      if (res) {
        this.$message.success(this.$t("page_resource_pool_success"));
        this.getPageRepairApply();
      }
    },
    changeRecord(record) {
      this.apply.applyCode = record.applyCode;
      this.apply.applyId = record.id;
      this.visible = true;
      // console.log("dsadssadsd", this.applyCode);
    },
    async createData() {
      let form = this.$refs._form_add;
      let data = await form.getAllData();
      // console.log(1111, data)
      if (!data) {
        return;
      }
      // const data: any = await this._form_add.manualSubmit()
      this.saveLoading = true;
      
      try {
        await repairRecordServiceProxy.createRepairApply(data);
        this.saveLoading = false;
        this.$message.success(this.$t("page_docdirectory_create_success"));
        this.showDialog = false;
        this.getPageRepairApply();
      } catch (e) {
        this.saveLoading = false;
      }
    },
    handleOk(e) {
      this.createData();
      this.visible = false;
    },
    handleCancel(e) {
      // console.log("Clicked cancel button");
      this.visible = false;
      // this.getRecordByDeviceId();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1000px !important;
}
</style>
